import React from 'react'

const DeleteModule = ({handleDelete, setSelectedDeleteID}) => {
  return (
        <div className='fixed top-28 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gray-100 p-6 rounded-md shadow-md'>
            <h3 className='text-2xl'>Are You Sure You Want to Delete?</h3>
            <div className='flex gap-4 mt-4'>
                <button onClick={handleDelete} className='bg-red-500 text-white text-sm font-semibold px-3 py-2 rounded-md'>Delete</button>
                <button onClick={() => setSelectedDeleteID(null)} className='bg-white text-gray-800 text-sm font-semibold px-3 py-2 rounded-md'>Cancel</button>
            </div>
        </div>
  )
}

export default DeleteModule
